export default __webpack_public_path__ + "static/media/globe.e9bfa76a.svg";